import Markdown from "components/markdown";
import { Box, BoxProps, ScrollSpyItem, Text } from "designsystem";
import React, { forwardRef, useState } from "react";
import { slugFromStrings } from "utils/slugs";
import LinkCard from "../link-card";
import LinkCardGrid from "components/link-card-grid";
//import { UseSelectStateChange } from "downshift";

interface LinkListProps {
  linkList: GatsbyTypes.LinkListNodeFragment;
  localizedContent?: GatsbyTypes.LinkListNodeFragment[];
}

const SpyComponent = forwardRef<HTMLElement, BoxProps<HTMLElement>>(
  (props, ref) => (
    <Box
      as="section"
      direction="column"
      paddingTop="xl" // 40px
      paddingBottom="xl" // 40px
      {...props}
      innerRef={ref}
    />
  )
);
SpyComponent.displayName = "LinkStepWrapperScrollSpy";

/**
 * This component is used in the Content Page to render a link list
 * @param param0
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const LinkList: React.FC<LinkListProps> = ({ linkList, localizedContent }) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [currentLinkList, setLinkList] =
    useState<GatsbyTypes.LinkListNodeFragment>(linkList);

  const body = currentLinkList.childContentfulLinkListBodyTextNode?.body;
  const slug = linkList.title ? slugFromStrings(linkList.title) : "";

  // const createOnSelectedItemChange = (
  //   changes: UseSelectStateChange<string>
  // ) => {
  //   const selectedLinkList = localizedContent?.find(
  //     (content) =>
  //       changes.selectedItem && content?.node_locale === changes.selectedItem
  //   );
  //   if (selectedLinkList !== linkList && selectedLinkList) {
  //     setLinkList(selectedLinkList);
  //   }
  // };
  return (
    linkList && (
      <ScrollSpyItem<BoxProps<HTMLElement>>
        spyComponent={SpyComponent}
        id={slug}
        hideId={true}
      >
        <Box direction="column">
          {/* Just commenting this out for now. TO DO: check will we use this in future and then remove or refactor functionality
          {currentLinkList.enableRegionPicker && (
            <RegionPicker
              onSelectedItemChange={createOnSelectedItemChange}
              initialSelectedItem={linkList.node_locale}
            />
          )} */}
          <Text as="h2" id={slug} className="legacy-scroll-margin-top">
            {currentLinkList.title}
          </Text>
          {body && <Markdown content={body} />}
          <LinkCardGrid>
            {currentLinkList.linkCards?.map(
              (linkCard) =>
                linkCard && <LinkCard key={linkCard.id} {...linkCard} />
            )}
          </LinkCardGrid>
        </Box>
      </ScrollSpyItem>
    )
  );
};
export default LinkList;
